import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class DynamicListManagerService {
  refreshDocumentsListControl = new Subject<void>();
  loadedFirstAccordionData = new Subject<void>();
}
